import React from 'react';

export const ArrowRight: React.FC<React.SVGProps<SVGSVGElement>> = ({ width, height, color }) => (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={width || '1em'} height={height || '1em'} viewBox="0 0 32 32">
        <path fill={color || 'currentColor'} d="M27.59 14.79 20 4.79a2 2 0 0 0-3.18 2.42L22 14H6a2 2 0 0 0 0 4h16l-5.17 6.79A2 2 0 1 0 20 27.21l7.62-10a2 2 0 0 0-.03-2.42Z" />
    </svg>
);
